module.exports = __webpack_public_path__ + "static/media/play_store.bb177cf0.svg";